module.exports = __webpack_public_path__ + "../assets/img/405954a0b121f47e4e663caabfee2662.svg";